import 'reflect-metadata'
import { AuthProvider } from '../Auth'
import { Outlet } from 'react-router-dom'
import React, { useLayoutEffect } from 'react'
import { RouterProvider, useLocation, useNavigate } from '../Router/router'
import { RouterProviderProps } from 'react-router/dist/lib/components'
import { Router } from '@sentry/react/build/types/types'
import { queryParamsGlobal } from '../utils/queryParamsUtils/QueryParamsGlobal'
import { observer } from 'mobx-react-lite'

export const ReactRouterWrapper = observer(
  ({ children }: { children: React.ReactNode }) => {
    const location = useLocation()
    const navigate = useNavigate()

    useLayoutEffect(() => {
      queryParamsGlobal.setNavigate(navigate)
    }, [navigate])

    useLayoutEffect(() => {
      queryParamsGlobal.setPathname(location.pathname)
    }, [location.pathname])

    useLayoutEffect(() => {
      queryParamsGlobal.setSearch(location.search)
    }, [location.search])

    return <>{children}</>
  }
)

export const RootContent = ({
  AppComponent,
}: {
  AppComponent: React.FC<{ children?: React.ReactNode }>
}) => (
  <AuthProvider>
    <ReactRouterWrapper>
      <AppComponent>
        <Outlet />
      </AppComponent>
    </ReactRouterWrapper>
  </AuthProvider>
)

export const RootRouterProvider = <
  T extends Router | RouterProviderProps['router'],
>({
  routes,
}: {
  routes: T
  /*@ts-expect-error sentry Router type is incorrect, may be need to update library*/
}) => <RouterProvider router={routes} />
